import React, { Suspense, useContext, useEffect, useState } from "react";
import "./App.css";
import "./theme.css";
import "./common/common_css/Table_Css.css";
import "./common/common_css/Common_Css.css";
import "./common/common_css/Form_Css.css";
import "./common/common_css/Super_Super_Master.css";
import "./common/common_css/Exchnge_Modal_Css.css";
import "./common/common_component/all_matches_component/All_Matches_Component.css";
// import "./components/admin/management/super_super_master/Super_Super_Master.css";

import { Route, Routes } from "react-router-dom";

import { Spinner } from "react-bootstrap";
import ChangePassword_modal from "./common/common_modal/change_password_model/ChangePassword_modal";
import { Context } from "./utils/Context";

// Containers
const DefaultLayout = React.lazy(() => import("./layout/DefaultLayout"));

// Pages

const Page404 = React.lazy(() => import("./components/page404/Page404"));
const Page500 = React.lazy(() => import("./components/page500/Page500"));

function App({}) {
  const { ChangePass, setChangePass } = useContext(Context);
  return (
    <>
      <Suspense
        fallback={
          <div className="pt-3 text-center">
            <Spinner
              animation="grow"
              variant="primary"
              style={{
                width: "4rem",
                height: "4rem",
                color: "#fbca06",
                background: "#fbca06",
              }}
            />
          </div>
        }
      >
        <Routes>
          <Route path="*" name="Home" element={<DefaultLayout />} />
          <Route exact path="/404" name="Page 404" element={<Page404 />} />
          <Route exact path="/500" name="Page 500" element={<Page500 />} />
        </Routes>
      </Suspense>
      <ChangePassword_modal
        show={ChangePass}
        onHide={() => setChangePass(false)}
      />
    </>
  );
}

export default App;
